import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, retry, tap } from 'rxjs/operators';

import { DataAccessOrganizationsService } from '@unico-people/shared/dashboard/data-access-organizations';

import * as fromActions from '../actions';
import * as fromStore from '../index';
import { SessionStorage } from '@unico-people/shared/utils/storage';

export interface Organization {
  accounts: [{}];
  customFielsa: {};
  description: string;
  name: string;
}

@Injectable()
export class OrganizationEffects {
  constructor(
    private actions$: Actions,
    private organizationService: DataAccessOrganizationsService,
    private store: Store<fromStore.DashboardState>
  ) {}

  callback$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadOrganization),
      mergeMap(res => {
        return this.organizationService.getOrganization(res.payload).pipe(
          map(callback => {
            if (!SessionStorage.getItem('currentAccount')) {
              SessionStorage.setItem('currentAccountName', callback[0].accounts[0].name);
              SessionStorage.setItem('currentAccount', callback[0].accounts[0].uid);
            }
            return fromActions.loadOrganizationSuccess({
              payload: callback
            });
          }),
          retry(2),
          catchError(err => of(fromActions.loadOrganizationFail(err)))
        );
      })
    )
  );

  callbackSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromActions.loadOrganizationSuccess),
        tap(res => {
          if (!SessionStorage.getItem('currentAccount')) {
            SessionStorage.setItem('currentAccount', res.payload.accounts[0].uid);
          }
        })
      ),
    { dispatch: false }
  );

  changeAccount$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromActions.changeAccount),
        tap(() => {
          this.store.dispatch(fromStore.loadDepartments());
          this.store.dispatch(fromStore.loadRoles());
          this.store.dispatch(fromStore.loadUnits());
        })
      ),
    { dispatch: false }
  );
}
